import React, { createContext, FC, ReactNode, useState } from "react";

export type BillingMenuContextProps = {
  isMenuOpen: boolean;
  setIsMenuOpen: (isMenuOpen: boolean) => void;
  isLanguageDropdownOpen: boolean;
  setIsLanguageDropdownOpen: (isLanguageDropdownOpen: boolean) => void;
  toggleLanguageDropdownOpen: () => void;
};

export const BillingMenuContext = createContext<BillingMenuContextProps>({
  isMenuOpen: false,
  setIsMenuOpen: () => undefined,
  isLanguageDropdownOpen: false,
  setIsLanguageDropdownOpen: () => undefined,
  toggleLanguageDropdownOpen: () => undefined,
});

interface BillingMenuProviderProps {
  children: ReactNode;
}

const BillingMenuProvider: FC<BillingMenuProviderProps> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] =
    useState<boolean>(false);

  const toggleLanguageDropdownOpen = () => {
    setIsLanguageDropdownOpen(
      (isLanguageDropdownOpen) => !isLanguageDropdownOpen
    );
  };

  return (
    <BillingMenuContext.Provider
      value={{
        isMenuOpen,
        setIsMenuOpen,
        isLanguageDropdownOpen,
        setIsLanguageDropdownOpen,
        toggleLanguageDropdownOpen,
      }}
    >
      {children}
    </BillingMenuContext.Provider>
  );
};

export default BillingMenuProvider;
